module.exports = {"Generacion de Estadisticas":"Generación de Estadísticas","Tipo Reporte":"Tipo Reporte","Visualizaciones":"Visualizaciones","Reportes Estadisticos":"Reportes Estadísticos","Fecha Desde":"Fecha Desde","Fecha Hasta":"Fecha Hasta","Grafico":"Gráfico","Generar":"Generar Visualización"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/estadisticas/es.json
// module id = 1918
// module chunks = 0